var myVar = setInterval(timer, 500);

function timer() {
  if (window.$) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js";
      document.getElementsByTagName("head")[0].appendChild(script);

    $(document).ready(function () {
      $("body").on("click", ".swell-customer-btn-login", function () {
        $(".drawer__root").addClass("drawer-active")
        $(".drawer__sign__in__root").removeClass("display__none");
        $(".drawer__register__root").addClass("display__none");
      })
      $("body").on("click", ".swell-customer-btn-register", function () {
        $(".drawer__root").addClass("drawer-active")
        $(".drawer__register__root").removeClass("display__none");
        $(".drawer__sign__in__root").addClass("display__none");
      })
      
      $("body").on("click", ".swell-share-referral-copy", function () {
        setTimeout(function () {
          $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://", ""));
          $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("https://", ""));
        }, 20);
      });

      $(document).on("swell:referral:success", function () {
        getreferrals();
      });

      $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown) {
        if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
          $(".refer-customer-error").remove();
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
        if (textStatus && textStatus === "Please enter a valid email address") {
          $(".refer-customer-error").remove();
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Enter email addresses seperated with commas</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
      });

      $(document).on("swell:initialized", function () {
        $(".swell-referral-loader").hide();
        var campaigns = spapi.activeCampaigns;
        campaigns.forEach(function (camp) {
          if (camp.type != "ReferralCampaign" && camp.type!="CreateAccountCampaign")
            $(".swell-campaign-list").append('<li class="swell-campaign id-' + camp.id + '"> <div class="swell-campaign-content swell-campaign-link" data-display-mode="modal"  data-campaign-id=' + camp.id + '  > <div class="swell-campaign-icon"> <span class="' + camp.icon + '"></span></div>  <div class="swell-campaign-image">  <div class="swell-campaign-content-holder"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content">' + camp.reward_text + '</span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content">' + camp.title + '</span> </div> </div> </div> </div> </li>');
        });

        var redemptions = spapi.activeRedemptionOptions;
        redemptions.forEach(function (redemp) {
          $(".swell-redemption-list").append('<li class="swell-redemption-option swell-redemption-link" data-redemption-option-id=' + redemp.id + '> <div class="swell-redemption-option-content"> <div class="swell-redemption-option-cost">' + redemp.name + '</div> <div class="swell-redemption-option-value">' + redemp.cost_text + '</div> </div> </li>');
        })
      });

      $(document).on("swell:setup", function () {
        $(".swell-post-checkout").css("display", "flex");
        $(".swell-post-checkout .checkout-heading .swell-referral-back-link").click(function () {
          $(".swell-post-checkout").css("display", "none");
        });
        $(".swell-referral-loader-tiers").hide();
        SwellConfig.Referral.initializeReferral(".swell-referral");
        if (spapi.customer.email) {
          getreferrals();
        }

        $(".swell-post-checkout").css("display", "flex");
        $(".swell-post-checkout .checkout-heading .swell-referral-back-link").click(function () {
          $(".swell-post-checkout").css("display", "none");
        });
        if ($(".swell-tier-table").length > 0) {
          SwellConfig.Tier.initializeDummyTier();
          SwellConfig.Tier.initializeCustomTierProperties();
          SwellConfig.Tier.initializeTiers(".swell-tier-table");
          // SwellConfig.Tier.applytierSlickSlider('.swell-tier-table-body');
        }
        $("body").on("click", ".swell-account-btn", function () {
          $(".swell-tier-table-body").slick("unslick");
        })
      })
    });
    stop();
  }
}
function stop() {
  clearInterval(myVar);
}

(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Tier = {
    getCustomerTierId: function () {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function () {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function (e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function (rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function (e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function () {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      //do whatever you want
    },
    initializeDummyTier: function () {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Tier 1",
        amount_spent_cents: 0,
        points_multiplier: "1.0",
        swellrequiredAmountSpent: "$0",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      }); 
    },
    initializeCustomTierProperties: function () {
      var activeVipTiers = spapi.activeVipTiers;
      activeVipTiers[0].spend = "Earn: 0-" + ((activeVipTiers[1].points_earned)-1) + " points <span>Per Calendar Year</span>";
      activeVipTiers[0].point_multiplier = "1.0x";
      activeVipTiers[0].exclusive_offers = "";
      activeVipTiers[0].coupon = "";
      activeVipTiers[0].member = "";
      activeVipTiers[0].early_sales = "";
      activeVipTiers[0].earn_more = "";

      activeVipTiers[1].spend = "Earn: " + ((activeVipTiers[1].points_earned)) + "-" + (((activeVipTiers[2].points_earned)) - 1) + " points <span>Per Calendar Year</span>";
      activeVipTiers[1].point_multiplier = "1.2x";
      activeVipTiers[1].exclusive_offers = "<div class='circle'></div>";
      activeVipTiers[1].coupon = "20% Off";
      activeVipTiers[1].member = "<div class='circle'></div>";
      activeVipTiers[1].early_sales = "<div class='circle'></div>";
      activeVipTiers[1].earn_more = "";

      activeVipTiers[2].spend = "Earn: " + ((activeVipTiers[2].points_earned)) + " points + <span>Per Calendar Year</span>";
      activeVipTiers[2].point_multiplier = "1.5x";
      activeVipTiers[2].exclusive_offers = "<div class='circle'></div>";
      activeVipTiers[2].coupon = "25% Off";
      activeVipTiers[2].member = "<div class='circle'></div>";
      activeVipTiers[2].early_sales = "<div class='circle'></div>";
      activeVipTiers[2].earn_more = "";
    },
    initializeTiers: function (containerSelector) {
      $(".swell-tier-table").append('<ul class="swell-tier-table-header"> <li class="swell-tier-list"> <div class="tier-list tier-status"></div> <div class="tier-list tier-name"></div> <div class="tier-list tier-value">Benefits</div> <div class="tier-list tier-multiplier">Point multiplier</div> <div class="tier-list tier-offers"><span>Exclusive Offers</span></div> <div class="tier-list">Coupon for entering tier</div> <div class="tier-list">Member-only sales</div> <div class="tier-list">Early access to new products</div> </li> </ul> <ul class="swell-tier-table-body"</ul> ');
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      var next_info = "";
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      for (var t = 0; t < tiers.length - 1; t++) {
        if (t == customer_tier_rank && spapi.authenticated) {
          tiers[t].current_status = "Current Status";
          if (t + 1 < tiers.length) {
            if ((tiers[t + 1].points_earned) - (spapi.customer.vip_tier_stats.points_earned) <= 0) {
              tiers[t + 1].current_status = "Earn 0 more points to reach " + tiers[t + 1].name;
            } else {
              tiers[t + 1].current_status = "Earn " + (((tiers[t + 1].points_earned) - (spapi.customer.vip_tier_stats.points_earned))) + " more points to reach " + tiers[t + 1].name;
            }
          }
        } else {
          if (tiers[t].current_status == null || tiers[t].current_status == "undefined") {
            tiers[t].current_status = "";
          }
        }
        $(".swell-tier-table-body").append('<li class="swell-tier-list swell-' + tiers[t].name + '" data-tier-id = "' + tiers[t].id + '"> <div class="tier-list tier-status status-rank' + t + '">' + tiers[t].current_status + '</div> <div class="tier-list tier-name"> <span>' + tiers[t].name + '</span></div> <div class="tier-list tier-value">' + tiers[t].spend + '</div> <div class="tier-list tier-multiplier">' + tiers[t].point_multiplier + '</div> <div class="tier-list">' + tiers[t].exclusive_offers + '</div> <div class="tier-list">' + tiers[t].coupon + '</div> <div class="tier-list">' + tiers[t].member + '</div> <div class="tier-list">' + tiers[t].early_sales + '</div> </li>');
        if (t == customer_tier_rank && spapi.authenticated) {
          $(".swell-tier-list[data-tier-id='" + tiers[t].id + "']").addClass("current-status");
          var status = $(".current-status .tier-name").html()
          $(".swell-tier-status .status-name").append(status);
        }
        if (tiers[t].current_status == "") {
          $(".status-rank" + t + "").css('visibility', 'hidden');
        }
      }
    },
    applytierSlickSlider: function (containerSelector) {
        $(containerSelector).slick({
          dots: true,
          infinite: true,
          speed: 300,
          centerMode: false,
          slidesToScroll: 1,
          slidesToShow: 3,
          prevArrow: false,
          nextArrow: false,
          responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }]
        });
    }
  }
}).call(this);


(function () {
  window.SwellConfig = window.SwellConfig || {};
  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",
        referralRegisterHeading: "<div class='refer-heading'>Refer a Friend</div>Give $<span>10</span>, Get $<span>10</span>",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Your email",
        referralRegisterFormSubmit: "Next",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "<div class='refer-heading'>Refer a Friend</div>Give $<span>10</span>, Get $<span>10</span>",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralReferFormSubmit: "Send",
        referralReferFormDetails: "Now, Enter your friends’ emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",
        referralReferMediaDetails: "You can also share your link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareTwitter: "Tweet",
        referralShareCopy: "Copy Link",
        referralFacebookIcon: "swell-referral-media-icon swell-icon-share",
        referralTwitterIcon: "swell-referral-media-icon swell-icon-tweet",
        referralLinkIcon: "swell-referral-media-icon swell-icon-copy-link",

        referralThanksHeading: "Thanks for referring!",
        referralThanksDetails: "Let your friends know to check their email.",
        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%=localization.referralRegisterHeading%></h2>   <p class="swell-referral-details"><%= localization.referralRegisterDetails %>  </p> <div class="swell-divider"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text"  name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail%>">  </li> <li class="swell-referral-form-list-field">              <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%=  localization.referralRegisterFormSubmit%>"> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%=localization.referralReferHeading%></h2>    <p class="swell-referral-details"><%=localization.referralReferDetails%> </p> <div class="swell-divider"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%=localization.referralReferFormEmails%>"> </li> <li class="swell-referral-form-list-field">              <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value=<%=localization.referralReferFormSubmit%>> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details">You can also share your link with the buttons below.</p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-facebook-share" aria-hidden="true"></i> Share </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-sms-mob" aria-hidden="true"></i> SMS </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-tweet" aria-hidden="true"></i> Tweet </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-fb-message" aria-hidden="true"></i> Message </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-rewards-copylink" aria-hidden="true"></i> Copy Link </div> </li> </ul> </div> </div>'
      }
    },
    initializeReferral: function (containerSelector) {
      var email = $(containerSelector).data("customer-email");
      if (email) {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    }
  };
}).call(this);

function getreferrals() {
  $('.table-data').html("");
  swellAPI.refreshCustomerDetails(function () {
    var recep = spapi.customer.referral_receipts;
    recep.forEach(function (rec) {
      var em = rec.email;
      var stat = rec.completed_at;
      if (stat) {
        $('.table-data').append("<tr> + <td>" + rec.email + "</td> <td> purchased $10 (earned) </td> </tr>");
      } else {
        $('.table-data').append("<tr> + <td>" + rec.email + "</td> <td> invited </td> </tr>");
      }
    });
  });
};
